import React from 'react';

import { Link } from 'react-router-dom';
import AdminAppBody from '../../../../components/admin/AdminAppBody';

const questions = [
  {
    id: 1,
    question: "What is the output of the following code? ```python print(type(10 / 2)) ```",
    type: "Mcq",
    yourAnswer: "<class 'int'>",
    correctAnswer: "<class 'float'>",
    status: "Incorrect"
  },
  {
    id: 2,
    question: "Which of the following is not a valid Python operator?",
    type: "Mcq",
    yourAnswer: "@",
    correctAnswer: "||",
    status: "Incorrect"
  },
  {
    id: 3,
    question: "What will be the output of the following code? ```python for i in range(3): print(i, end=' ')```",
    type: "Mcq",
    yourAnswer: "0 1 2 3",
    correctAnswer: "0 1 2",
    status: "Incorrect"
  }
];

const AssessmentQuestion = () => {
  return (
    <AdminAppBody
      content={
        <div className="container py-4">
          {/* Heading and Back Button */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="fw-bold">Assessment Review</h4>
            <Link to="/assessments-result">  <button className="btn btn-primary text-white rounded">
              <i className="bi bi-arrow-left me-1" /> Back
            </button></Link>
           
          </div>

          {/* Questions List */}
          {questions.map((q, index) => (
            <div key={q.id} className="border border-danger rounded mb-3 p-3">
              <h5 className="fw-bold text-primary">
                <span className="badge bg-primary me-2">{index + 1}</span>
                {q.question}
              </h5>
              <p><strong>Type:</strong> {q.type}</p>
              <p><strong>Your Answer:</strong> {q.yourAnswer}</p>
              <p><strong>Correct Answer:</strong> {q.correctAnswer}</p>
              <p>
                <strong>Status:</strong>{" "}
                <span className="text-danger fw-bold">
                  <i className="bi bi-x-circle-fill me-1" /> {q.status}
                </span>
              </p>
            </div>
          ))}
        </div>
      }
    />
  );
};

export default AssessmentQuestion;
